import { FlexContext } from "./flex-context";
import { FlexSectionController } from "./flex-section-controller";
import { FlexSectionSchema } from "./flex-section-schema";
import { isSectionEmbedded } from "./utils";

const getDefaultArray = (schema: FlexSectionSchema) => (schema.isOptional ? [] : [{}]);

const createSectionInitialValues = (sectionController: FlexSectionController, values: any, initialData: unknown): any => {
	return sectionController.schema.isArray
		? ((values as Array<any>) || getDefaultArray(sectionController.schema)).map((instanceValues) =>
			createSingleSectionInstanceInitialValues(sectionController, instanceValues, initialData)
		)
		: createSingleSectionInstanceInitialValues(sectionController, values || {}, initialData);
};

const createSectionPart = (sectionController: FlexSectionController, values: any, initialData: unknown) => {
	return isSectionEmbedded(sectionController.schema)
		? createSectionInitialValues(sectionController, values, initialData)
		: {
			[sectionController.schema.localizableKey]: createSectionInitialValues(
				sectionController,
				values[sectionController.schema.localizableKey],
				initialData
			),
		};
};

export const createSingleSectionInstanceInitialValues = (
	sectionController: FlexSectionController,
	values: any,
	initialData: unknown
): any => {
	const fieldInitialValues = sectionController.fieldControllers.reduce(
		(a, f) => ({ ...a, [f.schema.attribute.identifier]: f.mapInitialValue(values[f.schema.attribute.identifier], initialData) }),
		{} as any
	);
	const innerSectionInitialValues = sectionController.sectionControllers.reduce(
		(a, section) => ({ ...a, ...createSectionPart(section, values, initialData) }),
		{} as any
	);

	return { ...fieldInitialValues, ...innerSectionInitialValues };
};

export const createTypeInitialValues = (typeModel: FlexContext, values: any, initialData: unknown) => {
	return typeModel.sectionControllers.reduce((a, s) => ({ ...a, ...createSectionPart(s, values, initialData) }), {} as any);
};
